<template>
  <v-ons-page>
    <v-ons-toolbar>
      <div class="left">
        <v-ons-back-button />
      </div>
      <div class="center">食材を追加</div>
      <div class="right">
        <v-ons-toolbar-button @click="register()" :disabled="hasErrors"
          >登録</v-ons-toolbar-button
        >
      </div>
    </v-ons-toolbar>
    <v-ons-list>
      <InputIngredient
        :id="id"
        v-model="inputIngredients[id]"
        @remove="removeInputIngredient(id)"
        v-for="id in Object.keys(inputIngredients)"
        :key="id"
      />
    </v-ons-list>
    <div></div>
    <div class="add-button-area">
      <v-ons-fab @click="addForm()">
        <v-ons-icon icon="md-plus"></v-ons-icon>
      </v-ons-fab>
    </div>
  </v-ons-page>
</template>
<script>
import { v4 as UUID } from "uuid";
import Top from "../Top.vue";
import InputIngredient from "../../../../components/molecules/InputIngredient.vue";

export default {
  components: {
    InputIngredient,
  },
  data() {
    return {
      top: Top,
      inputIngredients: { [UUID()]: {} },
    };
  },
  computed: {
    hasErrors() {
      for (let id of Object.keys(this.inputIngredients)) {
        const ingredient = this.inputIngredients[id];
        if (!ingredient.name) {
          return true;
        }

        if (!ingredient.number) {
          return true;
        }

        if (!ingredient.unit || ingredient.unit == "") {
          return true;
        }
      }

      return false;
    },
  },
  methods: {
    addForm() {
      this.$set(this.inputIngredients, UUID(), {});
    },
    register() {
      const menuId = this.$store.state.navigator.menu.options.menu.id;
      const ingredients = Object.entries(this.inputIngredients).map(
        ([, ingredient]) => {
          return {
            menuId: menuId,
            name: ingredient.name,
            number: ingredient.number,
            unit: ingredient.unit,
          };
        }
      );
      this.$store.commit("ingredients/add", ingredients);
      this.$store.commit("navigator/menu/replace", Top);
      this.$ons.notification.toast("材料を登録しました。", { timeout: 2000 });
    },
    removeInputIngredient(id) {
      this.$delete(this.inputIngredients, id);
    },
  },
};
</script>
<style scoped>
.add-button-area {
  position: relative;
}

.add-button-area > .fab {
  position: absolute;
  right: 10px;
  top: 10px;
}
</style>
